import React from 'react';
import { cn } from '../../lib/utils';
import { MarketplaceCategory } from '../../lib/types';
import { Coffee, Pizza, Utensils, IceCream, Sandwich, Beef, Salad, Wine } from 'lucide-react';
interface CategoryChipsProps {
  categories: MarketplaceCategory[];
  activeCategory?: string;
  onSelect?: (categoryId: string) => void;
  className?: string;
}
// Helper to map icon names to Lucide components
const getIcon = (iconName: string | null) => {
  const icons: Record<string, React.ElementType> = {
    coffee: Coffee,
    pizza: Pizza,
    utensils: Utensils,
    'ice-cream': IceCream,
    sandwich: Sandwich,
    beef: Beef,
    salad: Salad,
    wine: Wine
  };
  const Icon = iconName && icons[iconName] ? icons[iconName] : Utensils;
  return <Icon className="w-5 h-5" data-id="element-229" />;
};
export function CategoryChips({
  categories,
  activeCategory,
  onSelect,
  className
}: CategoryChipsProps) {
  return <div className={cn('w-full overflow-x-auto pb-4 pt-2 hide-scrollbar', className)} data-id="element-230">
      <div className="flex gap-3 px-4 sm:px-6 lg:px-8 min-w-max" data-id="element-231">
        <button onClick={() => onSelect?.('')} className={cn('flex items-center gap-2 px-5 py-2.5 rounded-full font-medium transition-all duration-200 border', !activeCategory ? 'bg-brand-charcoal text-white border-brand-charcoal shadow-md' : 'bg-white text-gray-700 border-gray-200 hover:border-brand-amber hover:text-brand-amber')} data-id="element-232">
          <span data-id="element-233">Todos</span>
        </button>

        {categories.map(category => <button key={category.id} onClick={() => onSelect?.(category.id)} className={cn('flex items-center gap-2 px-5 py-2.5 rounded-full font-medium transition-all duration-200 border', activeCategory === category.id ? 'bg-brand-charcoal text-white border-brand-charcoal shadow-md' : 'bg-white text-gray-700 border-gray-200 hover:border-brand-amber hover:text-brand-amber')} data-id="element-234">
            {getIcon(category.icon_name)}
            <span data-id="element-235">{category.name}</span>
          </button>)}
      </div>
    </div>;
}